import { FetchAllUsers, UsersAuditViewModel } from "@mikros/library";
import {
  Box,
  Collapse,
  createTheme,
  Dialog,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { Key, useEffect, useRef, useState } from "react";
import ApiServices from "../../../service/apiService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

import { Alert, AuditDialog } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";
import { AuditHistory } from "./auditHistory";
import { NewUserAudit } from "./newUserAudit";
import { PerformanceAudit } from "./performaceAudit";
import AuthService from "../../../service/authService";
import { jwtDecode } from "jwt-decode";

export interface UserAuditDetailsProps {
  userAuditData: UsersAuditViewModel;

  totalCount: number;
  totalCountFunction: Function;
  search: boolean;
  searchFunction: Function;
  formData: any;
  formDataFunction: Function;
  hasMoreData?: Boolean;
  hasMoreDataFunction: Function;
  userData: FetchAllUsers;
  userDataFunction: Function;
}

export function UserAuditDetailsDup(props: UserAuditDetailsProps) {
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const intl = useIntl();
  const navigate = useNavigate();
  const childRef = useRef<any>();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [lastKey, setLastKey] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [fetchedDataBefore, setFetchedDataBefore] = useState(false);

  const [perfAuditDialog, setPerfAuditDialog] = useState<boolean>(false);
  const [auditHistoryDialog, setAuditHistoryDialog] = useState<boolean>(false);
  const [perfAuditData, setPerfAuditData] = useState<any>();
  const [auditHistoryData, setAuditHistoryData] = useState<any>();

  const [newAuditData, setNewAuditData] = useState<any>();
  const [newAuditDialog, setNewAuditDialog] = useState<boolean>(false);

  const [selectedUserId, setSelectedUserId] = useState<string>();
  const [selectedAuditName, setSelectedAuditName] = useState<string>();
  const [triggerFetch, setTriggerFetch] = useState<boolean>(false);

  const [auditorName, setAuditorName] = useState<string>("");
  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  const [errorFlag, setErrorFlag] = useState(false);

  const [employeeDetails, setEmployeeDetails] = useState({
    employeeName: "",
    auditName: "",
    branchName: "",
    userId: "",
    auditedBy: "",
  });
  const [employeeNewAuditDetail, setEmployeeNewAuditDetail] = useState({
    employeeName: "",
    branchName: "",
    userId: "",
  });

  const [employeeAuditDetails, setEmployeeAuditDetails] = useState({
    employeeName: "",
    auditName: "",
    department: "",
    designation: "",
    location: "",
    branch: "",
  });
  const [auditFormData, setAuditFormData] = useState({
    ratings: [],
    comments: " ",
    obtainedMarks: 0,
  });

  console.log(
    "has more data print in user audit details dup",
    props.hasMoreData
  );
  console.log("search value print in user audit details dup", props.search);

  const toggleNewAuditDialog = () => {
    console.log("clicked create new audit dialog", newAuditDialog);
    setNewAuditDialog(true);
  };
  const togglePerfAuditDialog = () => {
    console.log("clicked audit create new dialog", perfAuditDialog);
    setPerfAuditDialog(true);
  };
  const toggleAuditHistoryDialog = () => {
    console.log("clicked audit history dialog", auditHistoryDialog);
    setAuditHistoryDialog(true);
  };

  const paginatedData = props?.search
    ? rowsPerPage === -1
      ? props?.userData?.users
      : props?.userData?.users?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
    : rowsPerPage === -1
    ? props?.userData?.users
    : props?.userData?.users?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

  console.log("paginated data", paginatedData);
  const toTitleCase = (text: string) =>
    text
      ?.toLowerCase()
      ?.replace(/_/g, " ")
      ?.split(" ")
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      ?.join(" ");

  const dateFormatFunc = (dateString: string) => {
    if (!dateString) {
      return intl.formatMessage({ id: "naValue" });
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0"); //ensures 2  digit day
    const months = [
      intl.formatMessage({ id: "janValue" }),
      intl.formatMessage({ id: "febValue" }),
      intl.formatMessage({ id: "marValue" }),
      intl.formatMessage({ id: "aprValue" }),
      intl.formatMessage({ id: "mayValue" }),
      intl.formatMessage({ id: "junValue" }),
      intl.formatMessage({ id: "julValue" }),
      intl.formatMessage({ id: "augValue" }),
      intl.formatMessage({ id: "septValue" }),
      intl.formatMessage({ id: "octValue" }),
      intl.formatMessage({ id: "novValue" }),
      intl.formatMessage({ id: "decValue" }),
    ];
    const month = months[date.getMonth()]; // Get the month name

    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    //format time as hh:mm AM/PM (local time without seconds)
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm =
      hours >= 12
        ? intl.formatMessage({ id: "pmValue" })
        : intl.formatMessage({ id: "amValue" });
    hours = hours % 12; // to convert 24-format to 12-hour format
    hours = hours ? hours : 12; //to handle 0 hour
    const formattedTime = `${hours}:${minutes} ${ampm}`;
    return `${formattedDate} at ${formattedTime}`;
  };

  const handleAuditSubmit = (auditData: any) => {
    console.log("Received audit data from child:", auditData);
    setAuditFormData(auditData);
  };

  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");
    console.log("loading print value in handle change page", loading);
    console.log("search print value in user audit details dup", props.search);

    if (!loading && !props.search) {
      if (props.hasMoreData) {
        fetchUsers(rowsPerPage, lastKey);
      }
    }
  };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value:", newRowsPerPage);

    setRowsPerPage(newRowsPerPage);

    if (!props.search) {
      props.formDataFunction({
        firstName: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });

      setPage(0); // Reset to first page
      setLastKey(null); // Reset pagination key
      props.searchFunction(false);
      props.userDataFunction({ users: [] }); // Clear previous user data
      fetchUsers(newRowsPerPage, ""); // Use newRowsPerPage directly
    }
  };

  function handleSearchFunction() {
    props.searchFunction(false);
    console.log("search function handle called");
  }

  function fetchUsers(limit: number, key: string) {
    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
    });
    let api = ApiServices.getInstance();
    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/user`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
            // props.hasMoreDataReference.current = !!data?.lastKey;

            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);

      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            props.userDataFunction(data);
            const totalUserCount = data?.users?.length;
            props.totalCountFunction(totalUserCount);
            setLastKey(data.lastKey);
            // props.hasMoreDataReference.current = !!data?.lastKey;
            console.log("data last key when limit 20", data?.lastKey);
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }

    //need to check if correct// because duplicated maybe present
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/user?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data?.errorMessage);
            return;
          } else {
            // Append only when paginating
            props.userDataFunction((prevData: any) => ({
              ...prevData,
              users: [...prevData?.users, ...data?.users],
            }));
            props.totalCountFunction(
              (prevCount: any) => prevCount + (data?.users?.length || 0)
            );
            setLastKey(data.lastKey);
            console.log("data last key when last key not null", data?.lastKey);

            // props.hasMoreDataReference.current = !!data?.lastKey;
            if (props.hasMoreDataFunction) {
              props.hasMoreDataFunction(!!data?.lastKey);
            }
            setLoading(false);
            setFetchedDataBefore(true); // Prevent unnecessary re-fetching
          }
        });
    }
  }

  type UserDataType = (typeof props.userData.users)[number];
  const totalPages =
    props?.userData?.users?.length > 0
      ? Math.ceil(props?.userData?.users?.length / rowsPerPage)
      : 1;

  function Row(props: { row: UserDataType }) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    const [auditData, setAuditData] = useState<
      {
        latestAudit: string;
        auditName: string;
        auditId: string;
        userAuditId: string;
        scorePercentage: number;
        actualScore: number;
        auditResponse: {
          Q: string; // Question
          R: number; // Response score
          C: string[]; // Comments array
        }[];
        auditDate: string;
        comments: string;
        auditedBy: string;
        trending: "UP" | "DOWN" | "NEUTRAL";
      }[]
    >([]);

    const [loading, setLoading] = useState(false);
    const [dataFetched, setDataFetched] = useState(false);

    const fetchAuditData = async () => {
      // Skip API call if data was already fetched
      if (dataFetched) {
        return;
      }
      setLoading(true);
      try {
        const api = ApiServices.getInstance();
        const response = await api
          .makeRequest(
            `${accountInstance.accntId}/useraudit/${row.userId}`,
            "GET"
          )
          .then(async (response) => {
            if (response && response.errorMessage) {
              console.log("entered error code handling in user audit detail");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(response.errorMessage);
              return;
            } else {
              setAuditData(response);
              setDataFetched(true); // Mark data as fetched
            }
          });
      } catch (error) {
        console.error("Error fetching audit data:", error);
      } finally {
        setLoading(false);
      }
    };

    const handleExpandRow = () => {
      setOpen(!open);
      console.log("open value in handle expand row", open);
      if (!open) {
        fetchAuditData();
      }
    };
    console.log("open value", open);
    console.log("auditData in user audit details dup", auditData);

    return (
      <>
        <TableRow
          sx={{
            "& > *": {
              borderBottom: open ? "none" : "1px solid rgba(223,224,224,1)",
            },
            backgroundColor: open
              ? "transparent"
              : "var(--color-mk-primary-20)",
            "&:hover": open
              ? {
                  backgroundColor: "#FFF !important", // Sets the background color to white on hover
                }
              : {},
          }}
        >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={handleExpandRow}
              disableRipple
              disableFocusRipple
              style={{
                backgroundColor: "transparent", // Ensure no background color on hover
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent", // Prevent hover background color
                },
                "&:focus": {
                  backgroundColor: "transparent", // Prevent focus background color
                },
              }}
            >
              {open ? (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary ${
                    open ? "rotate-90" : ""
                  }`}
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary`}
                />
              )}
            </IconButton>
          </TableCell>
          <TableCell>
            {/* {row.username} */}
            {row?.userProfile?.firstName} {row?.userProfile?.lastName}
          </TableCell>
          <TableCell>{row.department}</TableCell>
          <TableCell>{row.designation}</TableCell>
          <TableCell>{row.location}</TableCell>
          <TableCell>{row.branchName}</TableCell>

          {/* <TableCell>{row.score}%</TableCell> */}
          <TableCell>
            {row.scorePercentage !== undefined && row.scorePercentage !== null
              ? `${row.scorePercentage}`
              : ""}
          </TableCell>

          <TableCell>
            {row.trending === "UP" ? (
              <FontAwesomeIcon
                icon={["fas", "fa-arrow-trend-up" as IconName]}
                className="h-5 w-5 mx-3 hover:cursor-pointer text-mk-bright-green"
              />
            ) : row.trending === "DOWN" ? (
              <FontAwesomeIcon
                icon={["fas", "fa-arrow-trend-down" as IconName]}
                className={"h-5 w-5 mx-3 hover:cursor-pointer text-mk-red"}
              />
            ) : row.trending === "NEUTRAL" ? (
              <div>
                <FormattedMessage id="userAuditDetails.neutral" />
              </div>
            ) : null}
          </TableCell>

          <TableCell>
            <Box
              component="img"
              src={"/createNew.svg"}
              onClick={() => {
                handleSearchFunction();
                toggleNewAuditDialog();
                setNewAuditData(row);
                setEmployeeNewAuditDetail({
                  employeeName:
                    row.userProfile.firstName + " " + row.userProfile.lastName,
                  branchName: row.branchName,
                  userId: row.userId,
                });
              }}
              sx={{ cursor: "pointer" }}
            />
          </TableCell>
        </TableRow>

        <TableRow
          sx={{
            "& > *": {
              borderBottom: open ? "20px solid #F5F6FD !important" : "none",
              boxShadow: open ? "0px 4px 10px rgba(0,0,0,0.1)" : "none",
            },
            "&:hover": {
              backgroundColor: "#FFF !important", // Sets the background color to white on hover
            },
            marginBottom: open ? "16px" : "0",
            boxShadow: open ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none", // Shadow effect when open
            padding: open ? "16px" : "0", // Optional padding inside the row when open
            borderRadius: open ? "8px" : "0", // Optional: rounded corners when open
            zIndex: open ? 1 : "auto", // Brings the expanded row to the front
          }}
        >
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={2}>
                <Table
                  size="small"
                  aria-label="user details"
                  sx={{
                    "&:hover": {
                      backgroundColor: "#FFF !important", // Sets the background color to white on hover
                    },
                  }}
                >
                  <TableHead
                    className="MuiTableHead-root"
                    sx={{
                      backgroundColor: "#FFF",
                      "& .MuiTableRow-root:hover": {
                        background: "var(--color-mk-white) !important",
                      },
                      "&:hover": {
                        backgroundColor: "var(--color-mk-white) !important",
                      },
                    }}
                  >
                    <TableRow
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF !important", // Sets the background color to white on hover
                        },
                      }}
                    >
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.auditName" />
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.lastAuditDate" />
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.auditedBy" />
                      </TableCell>

                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.auditScore" />
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.percScore" />{" "}
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.trending" />{" "}
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.history" />{" "}
                      </TableCell>
                      <TableCell>
                        <FormattedMessage id="audit.userAuditView.createNew" />{" "}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "&:hover": {
                        backgroundColor: "#FFF !important", // Sets the background color to white on hover
                      },
                    }}
                  >
                    {auditData.length > 0 ? (
                      auditData.map((detail, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <TableCell sx={{ border: "none" }}>
                            {toTitleCase(detail.auditName)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {dateFormatFunc(detail.auditDate)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {toTitleCase(detail.auditedBy)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.actualScore}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail?.scorePercentage}%
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.trending === "UP" ? (
                              <FontAwesomeIcon
                                icon={["fas", "fa-arrow-trend-up" as IconName]}
                                className="h-5 w-5 mx-3 hover:cursor-pointer text-mk-bright-green"
                              />
                            ) : detail.trending === "DOWN" ? (
                              <FontAwesomeIcon
                                icon={[
                                  "fas",
                                  "fa-arrow-trend-down" as IconName,
                                ]}
                                className="h-5 w-5 mx-3 hover:cursor-pointer text-mk-red"
                              />
                            ) : detail.trending === "NEUTRAL" ? (
                              <div>
                                <FormattedMessage id="userAuditDetails.neutral" />
                              </div>
                            ) : null}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            <Box
                              src={"/notebookEye.svg"}
                              component="img"
                              onClick={() => {
                                setSelectedUserId(row.userId);
                                setSelectedAuditName(detail.auditName);
                                toggleAuditHistoryDialog();
                                setAuditHistoryData(row);
                                setEmployeeAuditDetails({
                                  employeeName: `${row.userProfile.firstName} ${row.userProfile.lastName}`,
                                  auditName: detail.auditName,
                                  department: row.department,
                                  designation: row.designation,
                                  location: row.location,
                                  branch: row.branchName,
                                });
                              }}
                              sx={{ cursor: "pointer" }}
                            />
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            <Box
                              component="img"
                              src={"/createNew.svg"}
                              onClick={() => {
                                togglePerfAuditDialog();
                                setPerfAuditData(row);
                                setEmployeeDetails({
                                  employeeName: `${row.userProfile.firstName} ${row.userProfile.lastName}`,
                                  auditName: detail.auditName,
                                  branchName: row.branchName,
                                  userId: row.userId,
                                  // auditedBy: detail.auditedBy,
                                  auditedBy:
                                    detail.auditedBy === auditorName
                                      ? detail.auditedBy
                                      : auditorName,
                                });
                              }}
                              sx={{ cursor: "pointer" }}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={9}
                          sx={{
                            textAlign: "center",
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important",
                            },
                          }}
                        >
                          <FormattedMessage id="audit.userAuditView.noAudits" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  useEffect(() => {
    fetchUsers(rowsPerPage, lastKey);
  }, [accountInstance.accntId]);

  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  useEffect(() => {
    if (subRef.current !== null) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            `${accountInstance.accntId}/audit/auditnames?userId=${subRef.current}`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
            } else {
              setAuditorName(data.userName);
            }
          });
      }
    }
  }, [subRef.current]);

  return (
    <div>
      {errorFlag && (
        <Dialog className="errorDialogue" open={true}>
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                navigate("/audit");
              }
            }}
          />
        </Dialog>
      )}

      {newAuditDialog && (
        <Dialog
          PaperProps={{
            style: {
              width: "80vw",
              height: "90vh",
              maxWidth: "90vw",
              maxHeight: "90vh",
              borderRadius: "10px",
              paddingTop: "16px",
              padding: "20px",
              boxSizing: "border-box",
            },
          }}
          open={true}
          onClose={() => setNewAuditDialog(false)}
        >
          <AuditDialog
            component={() => (
              <NewUserAudit
                ref={childRef}
                employeeDetails={employeeNewAuditDetail}
                auditFormData={auditFormData}
                userAuditData={props.userAuditData}
                auditFormDataFunction={setAuditFormData}
                auditDialogToggle={setNewAuditDialog}
                auditDialogValue={newAuditDialog}
                dataGridItems={newAuditData}
                submitAudit={handleAuditSubmit}
                onReload={() => fetchUsers(rowsPerPage, "")}
              ></NewUserAudit>
            )}
          />
        </Dialog>
      )}

      {perfAuditDialog && (
        <Dialog
          PaperProps={{
            style: {
              width: "80vw",
              height: "90vh",
              maxWidth: "90vw", // Override Material UI's default max width
              maxHeight: "90vh", //
              borderRadius: "10px",
              paddingTop: "16px", // equivalent to pt-4
              padding: "20px",
              boxSizing: "border-box",
            },
          }}
          open={true}
          onClose={() => setPerfAuditDialog(false)}
        >
          <AuditDialog
            component={() => (
              <PerformanceAudit
                ref={childRef}
                employeeDetails={employeeDetails}
                auditFormData={auditFormData}
                userAuditData={props.userAuditData}
                auditFormDataFunction={setAuditFormData}
                auditDialogToggle={setPerfAuditDialog}
                auditDialogValue={perfAuditDialog}
                dataGridItems={perfAuditData}
                submitAudit={handleAuditSubmit}
                triggerFetchFunction={setTriggerFetch}
                onReload={() => fetchUsers(rowsPerPage, "")}
              ></PerformanceAudit>
            )}
          />
        </Dialog>
      )}

      {auditHistoryDialog && (
        <Dialog
          PaperProps={{
            style: {
              width: "70vw",
              height: "70vh",
              maxWidth: "70vw", // Override Material UI's default max width
              maxHeight: "70vh", //
              borderRadius: "10px",
              paddingTop: "16px", // equivalent to pt-4
              padding: "20px",
              boxSizing: "border-box",
            },
          }}
          open={true}
          onClose={() => setPerfAuditDialog(false)}
        >
          <AuditDialog
            component={() => (
              <AuditHistory
                ref={childRef}
                employeeAuditHistDetails={employeeAuditDetails}
                auditDialogToggle={setAuditHistoryDialog}
                auditDialogValue={auditHistoryData}
                dataGridItems={auditHistoryData}
                userId={selectedUserId!!}
                auditName={selectedAuditName!!}
              ></AuditHistory>
            )}
          />
        </Dialog>
      )}

      <TableContainer component={Paper} elevation={0}>
        <Table size="medium" aria-label="collapsible table">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "#F5F6FD !important",
                },
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <TableCell
                sx={{
                  width: "3%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
              <TableCell
                sx={{
                  width: "18%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.userName" />
              </TableCell>
              <TableCell
                sx={{
                  width: "13%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.dept" />
              </TableCell>
              <TableCell
                sx={{
                  width: "13%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.desg" />
              </TableCell>
              <TableCell
                sx={{
                  width: "13%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.location" />
              </TableCell>
              <TableCell
                sx={{
                  width: "13%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.userView.branch" />
              </TableCell>
              <TableCell
                sx={{
                  width: "7%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="audit.userAuditView.score" />
              </TableCell>
              <TableCell
                sx={{
                  width: "7%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="audit.userAuditView.trending" />
              </TableCell>
              <TableCell
                sx={{
                  width: "10%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="audit.userAuditView.createNew" />
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {paginatedData?.length > 0 ? (
              paginatedData?.map((row: any, index: Key | null | undefined) => (
                <Row key={index} row={row} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="users.addNewUser.noUser" />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            backgroundColor: "#F5F6FD",
            padding: 0,
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text"
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        !props.hasMoreData &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        !props.hasMoreData &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                15,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              count={props.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${intl.formatMessage({
                  id: "ofValue",
                })} ${count} ${intl.formatMessage({ id: "items" })}`
              }
              ActionsComponent={() => null}
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>

      <div className="pb-[10%]"></div>
    </div>
  );
}
